import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { MessageModel } from '../types';
import { scrollToMessage } from '../utils';

@Component({
  selector: 'message-reply',
  templateUrl: './message-reply.component.html',
  styleUrls: ['./message-reply.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MessageReplyComponent {
  @Input() message!: MessageModel;
  @Input() set linkColor(linkColor: 'white' | 'blue' | string | undefined) {
    if (!linkColor) {
      linkColor = 'blue';
    }

    switch (linkColor) {
      case 'white':
        this._linkColor = 'var(--int-mes-color-text-01)';
        break;
      case 'blue':
        this._linkColor = 'var(--int-mes-color-link)';
        break;

      default:
        this._linkColor = linkColor;
        break;
    }
  }
  @Input() set color(color: 'white' | 'blue' | string | undefined) {
    if (!color) {
      color = 'white';
    }

    switch (color) {
      case 'white':
        this._color = 'var(--int-mes-color-white)';
        break;
      case 'blue':
        this._color = 'var(--int-mes-color-blue-800)';
        break;

      default:
        this._color = color;
        break;
    }
  }

  private _color?: string;
  private _linkColor?: string;

  get color() {
    return this._color;
  }

  get linkColor() {
    return this._linkColor;
  }

  onClickMessage(messageId: string) {
    scrollToMessage(messageId);
  }
}
